<app-protocolo-envio
    [titulo]="titulo"
    [instrucoesEnvio]="instrucoesEnvio"
    [routerLinkPesquisaLote]="['/integracao/scr/ipoc']"
    [tipoConteudoArquivo]="tipoConteudoArquivo"
    [textoBtnArquivoExemplo]="textoBtnArquivoExemplo"
    [tipoArquivoExemplo]="tipoArquivoExemplo"
    [tipoArquivoAceito]="'csv'"
    [mostrarBotoesDeOpcao]=false
>
</app-protocolo-envio>